<template>
  <div v-show="show == true">
    <img
      :src="img"
      alt=""
    >
  </div>
</template>

<script>
    export default {
        name: "ImageBig",
        props: {
            img: {
                type: String,
                default: ''
            },
            show: null,
            transition: {
                type: String,
                default: 'fade',
                required: false
            }
        }
    }
</script>

<style scoped>
    img {
        z-index: 999;
        position: absolute;
        top: 0;
        right: 0;
        left: 100%;
        width: 450px;

    }

</style>